/**
 * Analysis mode constants shared between frontend and server.
 * Single source of truth for valid analysis modes.
 */

export const ANALYSIS_MODES = ['standard', 'detailed', 'premium'] as const;

export type AnalysisMode = (typeof ANALYSIS_MODES)[number];

/** Check if a value is a valid AnalysisMode */
export function isValidAnalysisMode(value: unknown): value is AnalysisMode {
  return typeof value === 'string' && (ANALYSIS_MODES as readonly string[]).includes(value);
}
